import { render, staticRenderFns } from "./TableConfigFilterV2.vue?vue&type=template&id=5082bff6&"
import script from "./TableConfigFilterV2.vue?vue&type=script&lang=js&"
export * from "./TableConfigFilterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports